import widgetConfigJson from '../../data/widget-config.json';
import { Currency } from '../types/currency';
import { WidgetConfig } from '../types/widgetConfig';

export const widgetConfig = widgetConfigJson as WidgetConfig;

// Derive available currencies from config
export const currencies: Currency[] = [
  Currency.Eur,
  Currency.Usdc,
  Currency.Usdt,
  Currency.Chf,
  Currency.Czk,
  Currency.Pln,
].filter(
  c => widgetConfig.currencies.find(configCurrency => configCurrency.currencyCode === c)
);

// Available loan periods
export const periods: number[] = [3, 6, 12, 18, 24];

// Default values
export const defaults = {
  currency: Currency.Eur,
  period: 12,
};

// Display settings
export const display = {
  maxFiatDigits: 8,
};

// Get currency config by currency code
export function getCurrencyConfig(currency: Currency) {
  return widgetConfig.currencies.find(c => c.currencyCode === currency);
}
